import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/device' 

export default {
	/**
	 * 路灯下发日志 
	**/
	getDeviceLogList(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/getDeviceLogList',
			method:'get',
			params
		})
	}
}